import { render } from "./AdminApiTestView.vue?vue&type=template&id=e3cdcc30&scoped=true"
import script from "./AdminApiTestView.vue?vue&type=script&lang=js"
export * from "./AdminApiTestView.vue?vue&type=script&lang=js"

import "./AdminApiTestView.vue?vue&type=style&index=0&id=e3cdcc30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3cdcc30"]])

export default __exports__